<template>
  <div>
    <!-- 左侧和顶部布局的Sidebar -->
    <SidebarLogo :collapse="!appStore.sidebar.opened" />
    <el-scrollbar>
      <!-- <SidebarMenu :menu-list="menuFilterList" base-path="" /> -->
      <el-menu
        class="sidebar-menu"
        popper-class="left-menu-popper"
        mode="vertical"
        background-color="transparent"
        :text-color="variables['menu-text']"
        :active-text-color="variables['menu-active-text']"
        :unique-opened="false"
        :collapse-transition="false"
        :collapse="!appStore.sidebar.opened"
        :default-active="activeMenu"
      >
        <template v-for="item in menuFilterList">
          <el-sub-menu
            v-if="item?.childMenuNodeRespList"
            :key="item?.menuId"
            :index="item?.menuId"
          >
            <template #title>
              <el-icon v-if="item?.menuIcon">
                <component :is="item?.menuIcon" />
              </el-icon>

              <span>{{ item.name }}</span>
            </template>
            <el-menu-item
              v-for="child in item.childMenuNodeRespList"
              :key="child.menuId"
              :index="child.path"
              style="background-color: rgba(4, 18, 33, 0.9)"
              @click="handleSelect(child)"
            >
              {{ child.name }}
            </el-menu-item>
          </el-sub-menu>
          <el-menu-item
            v-else
            :key="`menuitem-${item?.path}`"
            :index="item?.path"
            @click="handleSelect(item)"
            style="background-color: rgba(4, 18, 33, 0.9)"
          >
            <el-icon>
              <component :is="item?.menuIcon" />
            </el-icon>
            <template #title>{{ item?.name }}</template>
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script setup lang="ts">
import { usePermissionStore, useAppStore } from "@/stores";
import { useRoute, useRouter } from "vue-router";
import variables from "@/styles/variables.module.scss"; // 样式
const route = useRoute();
const router = useRouter();
const appStore = useAppStore();
const permissionStore = usePermissionStore();
console.log(route.path, "route.path");
const activeMenu = computed(() => {
  return route.path;
});
const menuFilterList = computed(() => {
  return permissionStore.leftMenuList;
});
const handleSelect = (item: any) => {
  console.log(item);
  // 路由相同时 不跳转
  if (route.path == item.path) return;
  // appStore.changeActivePath(item.path);
  router.push(item.path);
};
console.log(menuFilterList.value);
</script>

<style lang="scss" scoped>
.el-scrollbar {
  height: calc(100vh - $navbar-height - 30px);
  .el-sub-menu {
    .el-menu--inline {
      padding: 4px 8px;
      background-color: #272f36;
      .el-menu-item {
        border-radius: 4px;
        height: 40px;
        opacity: 0.65;
        color: #fff;
        padding: 0 40px !important;
        margin: 2px 10px;
        &:hover {
          color: #fff;
          opacity: 1;
          background-color: #40484f;
        }
      }
      .el-menu-item.is-active {
        opacity: 1;
        background-color: #4f5e74 !important;
        border-radius: 10px;
        color: #ffffff;
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
  .sidebar-menu {
    .el-menu-item {
      // padding-left: 25px !important;
      font-weight: 400;
      color: #96a0b6;
      font-size: 14px;
    }
    .el-menu-item.is-active {
      // background-color: #4f5e74 !important;
      // width: 95%;
    }
  }
  .left-menu-popper {
    display: none;
  }
}
</style>
